import { combineReducers } from 'redux'

import * as actions from './actions'

import { UploadStatus, ResultStatus } from './constants'

// TODO - Put this boilerplate elsewhere - OR - install redux-actions and use handleAction(s) instead
const createReducer = (handlers, initialState) => (state = initialState, action) => (handlers.hasOwnProperty(action.type) ? handlers[action.type](state, action) : state)
const createDataReducer = (type, initialState) => createReducer({ [type]: (state, action) => action.payload }, initialState)

export const spreadsheetData = createDataReducer(actions.SET_SPREADSHEET_DATA, [])
export const validationData = createDataReducer(actions.SET_VALIDATION_DATA, {})

export const lastSuccessCount = createReducer({
    [actions.SET_LAST_SUCCESS_COUNT]: (state, action) => action.payload
}, 0)

export const uploadStatus = createReducer({
    [actions.SET_UPLOAD_STATUS]: (state, action) => action.payload
}, UploadStatus.IDLE)

export const resultStatus = createReducer({
    [actions.SET_RESULT_STATUS]: (state, action) => action.payload
}, ResultStatus.NONE)

// Semi-hack to name this damn thing properly because we can't just use 'admin'
export default {
    spreadsheet: combineReducers({
        spreadsheetData,
        validationData,
        lastSuccessCount,
        uploadStatus,
        resultStatus,
    })
}
